import { INITIAL_QUOTE } from '@/utils/constants';

export function setState(state, [field, value]) {
  state[field] = value;
}

export function setQuote(state, quote = {}) {
  state.quotes = {
    ...state.quotes,
    [quote.quoteId]: quote
  };
  state.quotesErrors[quote.quoteId] = undefined;
  finishQuoteLoading(state, quote.quoteId);
}

export function setQuoteError(state, id) {
  state.quotesErrors[id] = true;
  finishQuoteLoading(state, id);
}

export function finishQuoteLoading(state, id) {
  state.quotesLoading = {
    ...state.quotesLoading,
    [id]: false
  };
}

export function setQuoteLoading(state, id) {
  state.quotes = {
    ...state.quotes,
    [id]: { ...INITIAL_QUOTE, quoteId: id }
  };
  state.quotesLoading = {
    ...state.quotesLoading,
    [id]: true
  };
}
